import { lazy, Suspense } from "react";

const KoflipHome = lazy(() => import("./KoflipHome"));

export default function Home() {
  return (
    <Suspense
      fallback={
        <div className="min-h-screen bg-[var(--koflip-dust2)] flex items-center justify-center text-koflip-ink3">
          Loading…
        </div>
      }
    >
      <KoflipHome />
    </Suspense>
  );
}
